module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--mikepad",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_c('div', {
    staticClass: "binding"
  }), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pad"
  }, [_c('div', {
    staticClass: "line line1"
  }), _vm._v(" "), _c('div', {
    staticClass: "line line2"
  }), _vm._v(" "), _c('div', {
    staticClass: "line line3"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d75b89d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/Mikepad.vue
// module id = 675
// module chunks = 0